import { Heading, Image, Text } from '@wix/design-system'
import React, { CSSProperties, FC } from 'react'

import { ContentItem, ContentType } from '../CommonTemplate/types'
import { RichText } from '../RichText'
import s from './ContentRenderer.scss'

export type TextAlignment = 'start' | 'center' | 'end'

export type ContentRendererProps = {
  items?: ContentItem[]
  color?: string
  textMaxWidth?: string | number
  imageMaxWidth?: string | number
  videoMaxWidth?: string | number
  textAlign?: TextAlignment
  imageMarginBottom?: string | number
}

type ContentRendererItem = ContentItem | { type: ContentType.LIST; content: string[] }

export const ContentRenderer: FC<ContentRendererProps> = ({
  items = [],
  color = '#000',
  textMaxWidth = '100%',
  imageMaxWidth = 540,
  videoMaxWidth = 540,
  textAlign = 'start',
  imageMarginBottom = 30,
}) => {
  const res: ContentRendererItem[] = []

  for (const item of items) {
    if (item.type !== ContentType.LIST_ITEM) {
      res.push(item)
    }

    if (item.type === ContentType.LIST_ITEM) {
      const last = res[res.length - 1]
      if (last.type === ContentType.LIST) {
        last.content = [...last.content, item.content]
      } else {
        res.push({ type: ContentType.LIST, content: [item.content] })
      }
    }
  }

  return (
    <>
      {res.map(i => {
        if (i.type === ContentType.TEXT) {
          return (
            <div style={{ maxWidth: textMaxWidth, textAlign }}>
              <RichText key={i.content} color={color}>
                {i.content}
              </RichText>
            </div>
          )
        }

        if (i.type === ContentType.CENTERED_TEXT) {
          return (
            <div style={{ maxWidth: textMaxWidth, textAlign: 'center' }}>
              <RichText key={i.content} color={color}>
                {i.content}
              </RichText>
            </div>
          )
        }

        if (i.type === ContentType.IMAGE) {
          return (
            <div
              key={i.content}
              className={s.ContentRenderer__mediaContainer}
              style={{ maxWidth: imageMaxWidth, marginBottom: imageMarginBottom }}
            >
              <Image key={i.content} src={i.content} transparent fit="contain" />
            </div>
          )
        }

        if (i.type === ContentType.VIDEO) {
          return (
            <div key={i.content} className={s.ContentRenderer__mediaContainer} style={{ maxWidth: videoMaxWidth }}>
              <video key={i.content} width="100%" src={i.content} loop={true} autoPlay={true} muted={true} />
            </div>
          )
        }

        if (i.type === ContentType.TITLE) {
          return (
            <div key={i.content} style={{ '--title-color': color, maxWidth: textMaxWidth } as CSSProperties}>
              <Heading size="large" className={s.title}>
                {i.content}
              </Heading>
            </div>
          )
        }

        if (i.type === ContentType.LIST) {
          return (
            <Text key={i.content.join('')} listStyle="checkmark">
              <ul style={{ maxWidth: textMaxWidth }}>
                {i.content.map(j => (
                  <li key={j} style={{ marginBottom: 12, color }}>
                    {j}
                  </li>
                ))}
              </ul>
            </Text>
          )
        }

        return null
      })}
    </>
  )
}
